/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum definitionTypeEnum {
    STRING = 'string',
    INT = 'int',
    FLOAT = 'float',
    BLOB = 'blob',
    ENUM = 'enum',
}